import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent, KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'

@Component({
  selector: 'gd-type-editor-office-type',
  templateUrl: './type-editor-office-type.component.html',
  styleUrls: ['./type-editor-office-type.component.scss'],
  imports: [
    CommonModule,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS, KENDO_BUTTONS,
    GridComponent,
    DataBindingDirective,
    ToolbarTemplateDirective,
    GridToolbarFocusableDirective,
    AddCommandDirective,
    ButtonComponent,
    ColumnComponent,
    EditTemplateDirective,
    TextBoxDirective,
    FormsModule,
    ReactiveFormsModule,
    CellTemplateDirective,
    CommandColumnComponent,
    FocusableDirective,
    EditCommandDirective,
    SaveCommandDirective,
    CancelCommandDirective,
  ]
})
export class TypeEditorOfficeTypeComponent extends GridEditorBaseComponent {
  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  initGrid(): void {
    this.typesService.getOfficeType().subscribe((response) => {
      this.repState.officeTypes = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const officeType = formGroup.value
    this.typesService.submitOfficeTypeUpdate(officeType).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        officeTypeID: 0,
        officeTypeDescription: null,
        active: true,
      },
    )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(officeType: any): UntypedFormGroup {
    return this.formBuilder.group({
      officeTypeID: officeType.officeTypeID,
      officeTypeDescription: [
        officeType.officeTypeDescription,
        Validators.required,
      ],
      active: officeType.active,
    })
  }
}
